<template>
	<div>
		<div>
			<span class="xbed-sub-title">房间库存明细表</span>
		</div>

		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>麗家会</BreadcrumbItem>
				<BreadcrumbItem>房间物资出入库表</BreadcrumbItem>
				<BreadcrumbItem>房间库存明细表</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
		<Form inline @submit.native.prevent="preventSubmit">
			<FormItem label="创建时间：" :label-width="90">
				<DatePicker type="daterange" v-model="dateRange" placeholder="请选择" style="width: 240px" :clearable="false"></DatePicker>
			</FormItem>
			<FormItem label="一级类别：" :label-width="90">
				<Select style="width: 150px" v-model="query.goodsCatalog">
					<Option :value="0">全部</Option>
					<Option :value="1">个护用品</Option>
					<Option :value="2">布草</Option>
					<Option :value="3">家电</Option>
					<Option :value="4">家具</Option>
					<Option :value="5">家居装饰</Option>
					<Option :value="6">其他</Option>
				</Select>
			</FormItem>
			<FormItem label="出入库类型：" :label-width="100">
				<Select style="width: 150px" v-model="query.entryExitType">
					<Option :value="0">全部</Option>
					<Option :value="1">入库</Option>
					<Option :value="2">出库</Option>
				</Select>
			</FormItem>
			<FormItem label="更新类型：" :label-width="90">
				<Select style="width: 150px" v-model="query.updateType">
					<Option :value="0">全部</Option>
					<Option :value="1">期初</Option>
					<Option :value="2">更换</Option>
					<Option :value="3">补充</Option>
				</Select>
			</FormItem>
			<br>
			<FormItem label="物品名称：" :label-width="90">
				<Input v-model="query.goodsName"></Input>
			</FormItem>
			<FormItem label="关联单号：" :label-width="90">
				<Input v-model="query.orderNo"></Input>
			</FormItem>
			<FormItem label="关联城市：" :label-width="90">
				<Input v-model="query.associatedCityName"></Input>
			</FormItem>
			<FormItem label="">
				<Button type="primary" @click="search">查询</Button>
			</FormItem>
			<FormItem label="">
				<Button type="primary" @click="exportExcal" :loading="exportBtn">导出表格</Button>
			</FormItem>
		</Form>
		<Table stripe :columns="table.columns" :data="table.data" :loading="table.loading"></Table>
		<div style="margin: 10px;overflow: hidden">
			<Page show-sizer placement="top" :current="query.page" :total="table.total" :page-size="query.size" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
		</div>
	</div>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
import Moment from "moment";
import Config from "@/config";

export default {
	created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
		this.query.roomId = Utils.getUrlParameterByName( 'roomId' )
	},
	mounted() {
		this.roomGoodInventoryDetailList();
		this.$Notice.config( {
			top: 200
		} )
	},
	data() {
		return {
			exportBtn: false,
			dateRange: [
				Moment().subtract( 6, 'day' ).format( 'YYYY-MM-DD' ),
				Moment().format( 'YYYY-MM-DD' )
			],
			query: {
				roomId: '',
				page: 1,
				size: 10,
				endDate: "",
				entryExitType: 0,
				goodsCatalog: 0,
				goodsName: "",
				orderNo: "",
				startDate: "",
				associatedCityName: "",
				updateType: 0
			},
			queryParams: {
				roomId: '',
				page: 1,
				size: 10,
				endDate: "",
				entryExitType: 0,
				goodsCatalog: 0,
				goodsName: "",
				orderNo: "",
				startDate: "",
				associatedCityName: "",
				updateType: 0
			},
			table: {
				loading: false,
				data: [],
				total: 0,
				columns: [
					{
						title: "创建时间",
						align: "center",
						width: 120,
						key: "createDate",
						render: ( h, param ) => {
							return h(
								"span",
								param.row.createDate ? Moment( param.row.createDate ).format( "YYYY-MM-DD HH:mm:ss" ) : ''
							);
						}
					},
					{
						title: "房间名称",
						align: "center",
						width: 150,
						key: "roomName"
					},
					{
						title: "房间id",
						align: "center",
						width: 120,
						key: "roomId"
					},
					{
						title: "城市",
						align: "center",
						width: 120,
						key: "associatedCityName"
					},
					{
						title: "物品id",
						align: "center",
						width: 120,
						key: "goodsId"
					},
					{
						title: "物品名称",
						align: "center",
						width: 150,
						key: "goodsName"
					},
					{
						title: "物料编号",
						align: "center",
						width: 120,
						key: "stockNumber"
					},
					{
						title: "一级类别",
						align: "center",
						width: 120,
						key: "goodsCatalog",
						render: ( h, params ) => {
							const status = [
								"",
								"个护用品",
								"布草",
								"家电",
								"家具",
								"家居装饰",
								"其他",
							][params.row.goodsCatalog];
							return h( "span", {}, status );
						}
					},
					{
						title: "规格",
						align: "center",
						width: 120,
						key: "goodsDesc"
					},
					{
						title: "出入库类型",
						align: "center",
						width: 120,
						key: "entryExitType",
						render: ( h, p ) => {
							return h( "div", {}, p.row.entryExitType == 1 ? "入库" : p.row.entryExitType == 2 ? "出库" : '' );
						}
					},
					{
						title: "更新类型",
						align: "center",
						width: 120,
						key: "updateType",
						render: ( h, p ) => {
							return h( "div", {}, ["", "期初", "更换", "补充"][p.row.updateType] );
						}
					},
					{
						title: "更新数量",
						align: "center",
						width: 120,
						key: "updateNumber"
					},
					{
						title: "单价",
						align: "center",
						width: 120,
						key: "unitPrice",
						render: ( h, params ) => {
							const unitPrice = params.row.unitPrice
								? ( params.row.unitPrice / 100 ).toFixed( 2 )
								: '-';
							return h( "span", unitPrice );
						}
					},
					{
						title: "金额",
						align: "center",
						width: 120,
						key: "totalPrice",
						render: ( h, params ) => {
							const totalPrice = params.row.totalPrice ? ( params.row.totalPrice / 100 ).toFixed( 2 ) : '-';
							return h( "span", totalPrice );
						}
					},
					// {
					//   title: "税额",
					//   align: "center",
					//   width: 120,
					//   key: "taxPrice",
					//   render: (h, params) => {
					//   const taxPrice = params.row.taxPrice
					//     ? (params.row.taxPrice / 100).toFixed(2)
					//     : 0;
					//   return h("span", taxPrice);
					//  }
					// },
					// {
					//   title: "价税合计",
					//   align: "center",
					//   width: 120,
					//   key: "totalPriceWithTax",
					//   render: (h, params) => {
					//   const totalPriceWithTax = params.row.totalPriceWithTax
					//     ? (params.row.totalPriceWithTax / 100).toFixed(2)
					//     : 0;
					//   return h("span", totalPriceWithTax);
					//  }
					// },
					{
						title: "关联单号",
						align: "center",
						width: 230,
						key: "cleanOrderNo"
					}
				]
			}
		};
	},
	methods: {
		changePage( page ) {
			this.queryParams.page = page;
			this.roomGoodInventoryDetailList();
		},
		changePageSize( pageSize ) {
			this.queryParams.page = 1;
			this.queryParams.size = pageSize;
			this.roomGoodInventoryDetailList();
		},
		search() {
			this.queryParams = Object.assign( {}, this.query );
			this.roomGoodInventoryDetailList();
		},
		async roomGoodInventoryDetailList() {
			this.queryParams.startDate = this.dateRange[0]
				? Moment( this.dateRange[0] ).format( "YYYY-MM-DD HH:mm:ss" )
				: "";
			this.queryParams.endDate = this.dateRange[1]
				? Moment( this.dateRange[1] ).format( "YYYY-MM-DD 23:59:59" )
				: "";
			this.queryParams.goodsCatalog = this.query.goodsCatalog == 0 ? '' : this.query.goodsCatalog;
			this.queryParams.entryExitType = this.query.entryExitType == 0 ? '' : this.query.entryExitType;
			this.queryParams.updateType = this.query.updateType == 0 ? '' : this.query.updateType;
			this.queryParams.roomId = this.query.roomId;
			// 加载loading
			this.table.loading = true;
			const resp = ( await API.omsAPI[
				this.env
			].cleaner.roomGoodInventoryDetailList( this.queryParams, this.token ) ).data;
			if ( resp.retCode ) {
				this.$Notice.error( {
					title: "获取数据失败",
					desc: resp.msg
				} );
			}
			this.table.data = resp.content;
			this.table.total = resp.totalCount;
			this.table.loading = false;
		},
		// 导出表格
		exportExcal() {
			if ( !Utils.hasPermission( 'excel_MmMonthlyRoomGoodsInventories' ) ) {
				this.$Notice.error( {
					title: "无权限操作",
				} );
				return
			}
			let params = {
				startDate: this.queryParams.startDate,
				endDate: this.queryParams.endDate,
				goodsCatalog: this.queryParams.goodsCatalog,
				entryType: this.queryParams.entryExitType,
				updateType: this.queryParams.updateType,
				goodsName: this.queryParams.goodsName,
				orderNo: this.queryParams.orderNo,
				roomId: this.queryParams.roomId,
				associatedCityName: this.queryParams.associatedCityName,
				page: 1,
				size: 99999,
			};
			const initParam = params => {
				let paramStr = "";
				Object.keys( params ).forEach( item => {
					if ( params[item] !== "" ) {
						paramStr += item + "=" + params[item] + "&";
					}
				} );
				return paramStr.substring( 0, paramStr.lastIndexOf( "&" ) );
			};
			let paramStr = initParam( params );
			let url = `${ Config[this.env].analysisUrl }excel/MmRoomGoodsInventoryParticular?${ paramStr }`;
			// window.open(url, "_blank");
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, "exportBtn" )

		},
		preventSubmit() {
			return false;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/pages/cleaner/inventory/inventory-details.vue